module.exports = __webpack_public_path__ + "static/solution-brand-0efdf49b9fec5c0f8080d8e582b655ad.png";